<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
    <md-card>
    <input v-model="checker.id" :readonly="true" type="hidden"/>
      <md-card-content>
        <div class="md-layout">

          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider
                    rules="checkerdate"
                    ref="checker_date"
                    v-slot="{ errors }"
                  >
                    <md-field class="md-invalid">
                      <label for="">Date</label>
                      <md-input type="date" required v-model="checker.checker_date"/>
                      <validation-error
                        :errors="apiValidationErrors.checker_date"
                      />
                    <span class="md-error">{{ errors[0] }}</span>
                    </md-field>
                  </validation-provider>
          </div>

          <div class="md-layout-item  md-small-size-100">

                  
                  <validation-provider
                    rules="policeno"
                    ref="vehicle_plate_no"
                    v-slot="{ errors }"
                  >
                    <md-field class="md-invalid">
                      <label for="">Plate No</label>
                      <md-input required v-model="checker.vehicle_plate_no"/>
                      <validation-error
                        :errors="apiValidationErrors.vehicle_plate_no"
                      />
                    <span class="md-error">{{ errors[0] }}</span>
                    <md-button :disabled="!checker.vehicle_plate_no" class="md-icon-button md-round md-info md-dense" v-on:click="findVehiclePlatNo()"><md-icon >search</md-icon></md-button>
                    </md-field>
                  </validation-provider>
               </div>

            <div class="md-layout-item md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Vehicle No</label>
                  <md-input v-model="checker_vehicle_door_text" disabled />
                  <!-- <md-button style="background-color:green;" class="md-icon-button md-round md-info md-dense" v-on:click="findVehicle">
                    <md-icon >search</md-icon>
                  </md-button> -->
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>

            
           

            <!-- <div class="md-layout-item  md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Plate No</label>
                  <md-input v-model="checker_vehicle_plate_text" readonly/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_plate_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div> -->
          </div>

          <div class="md-layout">
            <div class="md-layout-item  md-small-size-100">
                <md-field class="md-invalid">
                  <label for="">Chassis No</label>
                  <md-input required v-model="checker_vehicle_chassis_text"/>
                </md-field>
            </div>

            <div class="md-layout-item  md-small-size-100">
                <md-field class="md-invalid">
                  <label for="">Engine No</label>
                  <md-input required v-model="checker_vehicle_engine_text"/>
                </md-field>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item  md-small-size-100  md-size-50" >
              <validation-provider rules="pool" ref="checker_pool" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Eshed</label>
                  <md-select v-model="checker.checker_pool">
                    <md-option v-for="option in options_pool_list" :key="option.value" :value="option.id">
                      {{ option.pool_name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.checker_pool"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>

            
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-50">
              <div class="md-layout-item  md-small-size-100">
              <validation-provider rules="checkertype" ref="checker_type" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Checker Type</label>
                  <md-select v-model="checker.checker_type" required>
                    <md-option value="0">Enter</md-option>
                    <md-option value="1">Exit</md-option>
                    <md-option value="2">Identification/Mapping</md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.checker_type"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
              <div class="md-layout-item  md-small-size-100">
              <!-- <validation-provider rules="bbm" ref="checker_bbm" v-slot="{ errors }"> -->
                 <validation-provider  ref="checker_bbm" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>BBM</label>
                  <!-- <md-select v-model="checker.checker_bbm" required> -->
                  <md-select v-model="checker.checker_bbm" >
                    <md-option value="0">Penuh</md-option>
                    <md-option value="1">0</md-option>
                    <md-option value="2">0.5</md-option>
                    <md-option value="3">1</md-option>
                    <md-option value="4">1.5</md-option>
                    <md-option value="5">2</md-option>
                    <md-option value="6">2.5</md-option>
                    <md-option value="7">3</md-option>
                    <md-option value="8">3.5</md-option>
                    <md-option value="9">4</md-option>
                    <md-option value="10">4.5</md-option>
                    <md-option value="11">5</md-option>
                    <md-option value="12">5.5</md-option>
                    <md-option value="13">6</md-option>
                    <md-option value="14">6.5</md-option>
                    <md-option value="15">7</md-option>
                    <md-option value="16">7.5</md-option>
                    <md-option value="17">8</md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.vehicle_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
              </div>
              <div class="md-layout-item  md-small-size-100">
              <!-- <validation-provider rules="km" ref="checker_km" v-slot="{ errors }"> -->
                 <validation-provider ref="checker_km" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>KM</label>
                  <!-- <md-input type="text" v-on:keypress="NumbersOnly" v-model="checker.checker_km" required/> -->
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="checker.checker_km" />
                  <validation-error
                    :errors="apiValidationErrors.checker_km"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
              </div>
              <div class="md-layout-item  md-small-size-100">
                <md-field class="md-invalid">
                  <label>KM MSPF</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="checker.checker_km_mspf" readonly/>
                </md-field>
              </div>
              <div class="md-layout-item  md-small-size-100">
              <!-- <validation-provider rules="rit" ref="checker_rit" v-slot="{ errors }"> -->
                <md-field class="md-invalid">
                  <label>RIT</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="checker.checker_rit" />
                  <!-- <validation-error
                    :errors="apiValidationErrors.checker_rit"
                  />
                  <span class="md-error">{{ errors[0] }}</span> -->
                </md-field>
              <!-- </validation-provider> -->
              </div>
              <div class="md-layout-item  md-small-size-100">
              <!-- <validation-provider rules="drop" ref="checker_drop" v-slot="{ errors }"> -->
                <md-field class="md-invalid">
                  <label>DROP</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="checker.checker_drop" />
                  <!-- <validation-error
                    :errors="apiValidationErrors.checker_drop"
                  />
                  <span class="md-error">{{ errors[0] }}</span> -->
                </md-field>
              <!-- </validation-provider> -->
              </div>

              
            </div>
           
            <div class="md-layout-item md-size-50">
              <div class="md-layout-item  md-small-size-100">
                <md-field class="md-invalid">
                  <label>Checker Type Last Time</label>
                  <md-select v-model="checker_type_last_time" disabled>
                    <md-option value="0">Enter</md-option>
                    <md-option value="1">Exit</md-option>
                  </md-select>
                </md-field>
            </div>
              <div class="md-layout-item  md-small-size-100">
              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>BBM Last Time</label>
                  <md-select v-model="checker_bbm_last_time" disabled>
                    <md-option value="0">Enter</md-option>
                    <md-option value="1">Exit</md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.vehicle_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
              </div>
              <div class="md-layout-item  md-small-size-100">
                <md-field class="md-invalid">
                  <label>KM Last Time</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="checker_km_last_time" disabled/>
                </md-field>
              </div>
              <div class="md-layout-item  md-small-size-100">
                <md-field class="md-invalid">
                  <label>KM MSPF Last Time</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="checker_km_mspf_last_time" disabled/>
                </md-field>
              </div>
              <div class="md-layout-item  md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>RIT Last Time</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="checker_rit_last_time" disabled/>
                  <validation-error
                    :errors="apiValidationErrors.checker_rit"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
              </div>
              <div class="md-layout-item  md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>DROP Last Time</label>
                  <md-input type="text" v-on:keypress="NumbersOnly" v-model="checker_drop_last_time" disabled/>
                  <validation-error
                    :errors="apiValidationErrors.checker_drop"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
              </div>

              
            </div>
            
            <!-- <h4 style="font-weight:bold; margin-top:20px;">kondisi Kendaraan</h4> -->
          <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <h5 style="font-weight:bold; margin-top:20px;">Kondisi Kendaraan</h5>
            <md-radio v-model="checker.checker_berbau" :value="1">Berbau</md-radio>
            <md-radio v-model="checker.checker_berbau" :value="2">Tidak Berbau</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-size-50 md-small-size-100" style="margin-top:50px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_berbau_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_berbau_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>

          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-radio v-model="checker.checker_goresan" :value="1">Goresan</md-radio>
            <md-radio v-model="checker.checker_goresan" :value="2">Tidak Goresan</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-size-50 md-small-size-100" >

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_goresan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_goresan_remark"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>
          </div>
        
      </md-card-content>
      <modal ref="modalListVehicle">
        <template v-slot:header>
          <h3>List Vehicle</h3>
        </template>
        
        <template v-slot:body>
          <list-vehicle :data_id="$refs.modalListVehicle.data"/>
        </template>
      </modal>
    </md-card>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
import ListVehicle from "@/pages/Dashboard/Workshop/Checker/Modal/ListVehicle.vue";
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';


// mengirim pesan error ketika required field tidak diisi
extend('vehicle', {
  ...required,
  message: 'Vehicle Field is required'
});
extend('pool', {
  ...required,
  message: 'Eshed Field is required'
});
extend('checkertype', {
  ...required,
  message: 'Checker Type Field is required'
});
extend('bbm', {
  ...required,
  message: 'BBM Field is required'
});
extend('rit', {
  ...required,
  message: 'RIT Field is required'
});
extend('km', {
  ...required,
  message: 'KM Field is required'
});
extend('drop', {
  ...required,
  message: 'Drop Field is required'
});
extend('plate', {
  ...required,
  message: 'Plate No Field is required'
});

extend('checkerdate', {
  ...required,
  message: 'Date Field is required'
});
  
  export default {
     name: "add-daily-closing",

    props: ["checker"],

    components: {ValidationError, Modal, "list-vehicle" : ListVehicle },

    mixins: [formMixin],

    data: () => ({
      checker_vehicle_door_text: null,
      // checker_vehicle_plate_text: null,
      dataValid: false,
       checker_type_last_time: null,
        checker_bbm_last_time: null,
         checker_km_last_time: null,
         checker_km_mspf_last_time: null,
          checker_rit_last_time: null,
           checker_drop_last_time: null,
           checker_vehicle_engine_text: null,
           checker_vehicle_chassis_text: null,
           options_pool_list:null

      // checker_pool: null,
      // checker_type: null,
      // checker_bbm:null,
      // checker_km:null,
      // checker_rit: null,
      // checker_drop: null,
      // options_item_list: null,
    }),


  created() {
          this.getPoolData();
      },

  
    methods: {

      async getPoolData(){
        await this.$store.dispatch("workshop_pool/list");
        this.options_pool_list = await this.$store.getters["workshop_pool/list"]
      },

      findVehicle(){
      this.$refs.modalListVehicle.openModal()
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    modalCloseListVehicle(data){
      console.log(data)
      if(data.id){
       this.checker_vehicle_id = data.id
       this.checker_vehicle_door_text = data.vehicle_door_no
       this.checker_vehicle_plate_text = data.vehicle_plate_no
      }
      this.$refs.modalListVehicle.closeModal()
    },

      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List Checker' })
    },

    setData(data){
      this.checker.checker_vehicle_id = data.id
      // this.checker.vehicle_plate_no = data.vehicle_plate_no
      this.checker_vehicle_door_text = data.vehicle_door_no
      this.checker_vehicle_chassis_text = data.vehicle_chassis_no
      this.checker_vehicle_engine_text = data.vehicle_engine_no
      if(data.vehicle_last_checker){
        
        this.checker_type_last_time = data.vehicle_last_checker.checker_type
        this.checker_bbm_last_time = data.vehicle_last_checker.checker_bbm
        this.checker_km_last_time = data.vehicle_last_checker.checker_km
        this.checker_km_mspf_last_time = data.vehicle_last_checker.checker_km_mspf
        this.checker_rit_last_time = data.vehicle_last_checker.checker_rit
        this.checker_drop_last_time = data.vehicle_last_checker.checker_drop
        if(data.vehicle_last_checker && data.vehicle_last_checker.checker_date){
         this.getMileageMspf(data.id,data.vehicle_last_checker.checker_date,this.$moment(new Date()).format('YYYY-MM-DD'));
        }
      }
      this.dataValid = true

    },


    async findVehiclePlatNo(){
      var query = {}
      query.filter = {find_vehicle_plate_no:this.checker.vehicle_plate_no}
       await this.$store.dispatch("fms_vehicle/list",query);
       var data = await this.$store.getters["fms_vehicle/list"];
      if(Object.keys(data).length!=0){
           this.setData(data[0])

       }
       else{
         this.swalFindError()
         this.dataValid = false
          this.checker = []
       }
        //  this.swalFindError()
        //  this.dataValid = false
        //   this. checker.id = data.id
        //   this.checker.vehicle_plate_no = data.vehicle_plate_no
        //   this.checker.vehicle_door_no = data.vehicle_door_no
       
    },

    async getMileageMspf(vehicle_id,from,to){
      const data = {
        vehicle_id: vehicle_id,
        from: from,
        to: to,
      }
      await this.$store.dispatch("fms_vehicle/get_mileage_mspf",data);
      var dataResult = await this.$store.getters["fms_vehicle/fms_vehicle"];
      console.log(dataResult[0].mileage);
      this.checker.checker_km_mspf = dataResult[0].mileage

    },

    swalFindError(){
      Swal.fire({
          icon: 'error',
          title: 'Not Found',
          text: 'Data kendaraan tidak ditemukan',
        })
    },

    getData() {
        this.$emit('data', this.checker)
       
    },

    async getDataParent() {
      if(this.checker.checker_last_checker){
        
        this.checker_type_last_time = this.checker.checker_last_checker.checker_type
        this.checker_bbm_last_time = this.checker.checker_last_checker.checker_bbm
        this.checker_km_last_time = this.checker.checker_last_checker.checker_km
        this.checker_rit_last_time = this.checker.checker_last_checker.checker_rit
        this.checker_drop_last_time = this.checker.checker_last_checker.checker_drop
      }
    },

    async validateForm() {
      // const service_estimate_no = this.$refs['service_estimate_no'];
      // const checker_vehicle_plate_text = this.$refs['checker_vehicle_plate_text'];
      // const checker_vehicle_door_text = this.$refs['checker_vehicle_door_text'];
      const checker_pool = this.$refs['checker_pool'];
      const checker_type = this.$refs['checker_type'];
      // const checker_bbm = this.$refs['checker_bbm'];
      const checker_rit = this.$refs['checker_rit'];
      // const checker_km = this.$refs['checker_km'];
      const checker_drop = this.$refs['checker_drop'];
      const vehicle_plate_no = this.$refs['vehicle_plate_no'];
      const checker_date = this.$refs['checker_date'];

      let result = []
        // result.push(
        //     await service_estimate_no.validate().then(function(data){
        //     return data.valid
        //     })
        // )
      //   result.push(
      //   await checker_vehicle_plate_text.validate().then(function(data){
      //     return data.valid
      //   })
      // )
      // result.push(
      //   await checker_vehicle_door_text.validate().then(function(data){
      //     return data.valid
      //   })
      // )
        result.push(
        await vehicle_plate_no.validate().then(function(data){
          return data.valid
        })
      )

      result.push(
        await checker_date.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await checker_pool.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await checker_type.validate().then(function(data){
          return data.valid
        })
      )
      // result.push(
      //   await checker_bbm.validate().then(function(data){
      //     return data.valid
      //   })
      // )
      // result.push(
      //   await checker_rit.validate().then(function(data){
      //     return data.valid
      //   })
      // )
      // result.push(
      //   await checker_km.validate().then(function(data){
      //     return data.valid
      //   })
      // )
      // result.push(
      //   await checker_drop.validate().then(function(data){
      //     return data.valid
      //   })
      // )
      return result.every(Boolean)

    }
  }
};
</script>
